import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=11da5f07&"
import script from "./TemplateItem.vue?vue&type=script&lang=ts&"
export * from "./TemplateItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports